import { render } from "./HelpModal.vue?vue&type=template&id=56d15b7a&scoped=true"
import script from "./HelpModal.vue?vue&type=script&lang=js"
export * from "./HelpModal.vue?vue&type=script&lang=js"

import "./HelpModal.vue?vue&type=style&index=0&id=56d15b7a&lang=scss&scoped=true"
import "./HelpModal.vue?vue&type=style&index=1&id=56d15b7a&lang=scss"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d15b7a"]])

export default __exports__